module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_combo_duo_rec_motivo_2.ba01ec53.png";